import React from 'react';
import './Creatives.scss';

interface Creative {
  name: string;
  display: string;
  order: number;
}

interface CreativesProps {
  event: any;
}

const Creatives: React.FC<CreativesProps> = ({ event }) => {
  const creatives = event?.creatives || [];
  const creativesLabel = event?.content?.creatives_label || 'Creatives';

  if (!creatives || creatives.length === 0) {
    return null;
  }

  return (
    <div className="creatives-section">
      <h2 className="section-title">
        <i className="fas fa-music me-2"></i>
        {creativesLabel}
      </h2>
      
      <div className="creatives-grid">
        {creatives.map((creative: Creative, index: number) => (
          <div key={`${creative.name}-${index}`} className="creative-item">
            <div className="creative-image-container">
              <img
                src={creative.display}
                alt={creative.name}
                className="creative-image"
                loading="lazy"
              />
            </div>
            
            <div className="creative-info">
              <h3 className="creative-name">{creative.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Creatives;
